import { createSlice } from '@reduxjs/toolkit';
import { saveEmailDraftApi } from '../../../rtk-apis/distribution/saveEmailDraft';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const saveEmailDraftSlice = createSlice({
  name: 'saveEmailDraft',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveEmailDraftApi.pending, state => {
        state.loading = true;
      })
      .addCase(saveEmailDraftApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || 'Saved as draft';
      })
      .addCase(saveEmailDraftApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Save draft failed';
      });
  },
});

export const { clearState: clearSaveEmailDraftState } = saveEmailDraftSlice.actions;
export default saveEmailDraftSlice.reducer;
